module.exports = __webpack_public_path__ + "static/media/growth-lab-logo.2e5c6e27.png";